/**
* RelytArt
*
* Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International
* Copyright (c) 2022 RelytArt
*
* License: https://docs.google.com/document/d/1UD7jhCYWRXSxhx4A5vMeGVTjujwLM39BmvjwA0eFFfk/edit?usp=sharing
*
*/

// components - atoms
import LoadingSpinner from "components/atoms/LoadingSpinner/LoadingSpinner.js";

const Button = (props) => {
  // @props: alt - String
  // @props: className - String
  // @props: isLoading - Boolean
  // @props: style - Object
  // @props: type - String

  const { alt, className, isLoading, style, type } = props;
  const propsDrill = {
    ...props,
    alt: alt || "",
    className: className || "btn btn-primary",
    disabled: props.disabled || isLoading,
    style: { position: "relative", ...style },
    type: type || "button"
  };
  delete(propsDrill.isLoading);

  return (
    <button {...propsDrill}>
      {propsDrill.children}
      {isLoading && (
        <div
          className={"align-items-center d-flex justify-content-center"}
          style={{
            height: "100%",
            left: "0",
            position: "absolute",
            top: 0,
            width: "100%"
          }}
        >
          <LoadingSpinner style={{ height: "1.5rem", width: "1.5rem" }}/>
        </div>
      )}
    </button>
  );
};
export default Button;
